import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=76d87ac6&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"
import style0 from "./impressum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports